// coffeeBeans.js

export const coffeeBeans = [
  // Sample Structured Bean Records
  {
    name: "Colombian Supremo",
    roast: "Medium",
    origin: "Colombia",
    roaster: "Volcanica Coffee",
    process: "Washed",
    notes: "Sweet, balanced, chocolate, nutty"
  },
  {
    name: "Ethiopian Yirgacheffe",
    roast: "Light",
    origin: "Ethiopia",
    roaster: "Counter Culture Coffee",
    process: "Washed",
    notes: "Floral, citrus, tea-like"
  },
  {
    name: "Sumatra Mandheling",
    roast: "Dark",
    origin: "Indonesia",
    roaster: "Intelligentsia",
    process: "Wet-hulled",
    notes: "Earthy, full-bodied, low acidity"
  },
  {
    name: "Kenyan AA",
    roast: "Medium to Dark",
    origin: "Kenya",
    roaster: "Blue Bottle",
    process: "Washed",
    notes: "Bright, winey, berry"
  },
  {
    name: "Guatemala Huehuetenango",
    roast: "Light to Medium",
    origin: "Guatemala",
    roaster: "Stumptown",
    process: "Washed",
    notes: "Cocoa, citrus, toffee"
  },
  {
    name: "Panama Geisha",
    roast: "Light",
    origin: "Panama",
    roaster: "Onyx Coffee Lab",
    process: "Washed",
    notes: "Floral, jasmine, bergamot"
  },
  {
    name: "Ethiopia Wush Wush",
    roast: "Light",
    origin: "Ethiopia",
    roaster: "Black & White Coffee Roasters",
    process: "Natural",
    notes: "Tropical fruit, floral, complex"
  },
  {
    name: "Brazil Yellow Bourbon",
    roast: "Medium",
    origin: "Brazil",
    roaster: "Coffee Bros",
    process: "Natural",
    notes: "Nutty, smooth, chocolate"
  },
  {
    name: "Papua New Guinea Sigri",
    roast: "Medium",
    origin: "Papua New Guinea",
    roaster: "Temple Coffee",
    process: "Washed",
    notes: "Spice, sweet, earthy"
  },
  {
    name: "Rwanda Gishamwana",
    roast: "Light to Medium",
    origin: "Rwanda",
    roaster: "Sweet Bloom Coffee",
    process: "Washed",
    notes: "Stone fruit, honey, floral"
  }
];
